import { render, staticRenderFns } from "./ProfileConversationMessages.vue?vue&type=template&id=da542fae&"
import script from "./ProfileConversationMessages.vue?vue&type=script&lang=js&"
export * from "./ProfileConversationMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports